export class ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner {
    'snapshotLocation';
    'providerVolumeId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotLocation",
            "baseName": "snapshotLocation",
            "type": "SnapshotLocation",
            "format": ""
        },
        {
            "name": "providerVolumeId",
            "baseName": "providerVolumeId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner.attributeTypeMap;
    }
    constructor() {
    }
}
